const EditProfile = () =>
  import(
    /* webpackChunkName: "ProfileViews" */ '../views/profile/EditProfile.vue'
    );
const UserProfile = () =>
  import(
    /* webpackChunkName: "ProfileViews" */ '../views/profile/UserProfile.vue'
    );
const ProfileTabTickets = () =>
  import(
    /* webpackChunkName: "ProfileViews" */ '../views/profile/ProfileTabTickets.vue'
    );
const ProfileTabTeams = () =>
  import(
    /* webpackChunkName: "ProfileViews" */ '../views/profile/ProfileTabTeams.vue'
    );
const ProfileTabBadges = () =>
  import(
    /* webpackChunkName: "ProfileViews" */ '../views/profile/ProfileTabBadges.vue'
    );
const ProfileTabChallenges = () =>
  import(
    /* webpackChunkName: "ProfileViews" */ '../views/profile/ProfileTabChallenges.vue'
    );

export const routeProfile = [
  {
    path: 'profile/complete',
    name: 'CompleteProfile',
    component: EditProfile,
    meta: {
      action: 'complete',
      title: 'Complete your profile'
    }
  },
  {
    path: 'profile/edit',
    name: 'EditProfile',
    component: EditProfile,
    meta: {
      action: 'edit',
      title: 'Edit profile'
    }
  },
  {
    path: 'profile/:userId',
    name: 'UserProfile',
    component: UserProfile,
    redirect: 'profile/:userId/tickets',
    children: [
      {
        path: 'tickets',
        name: 'TicketsTab',
        component: ProfileTabTickets,
        meta: {
          title: 'Profile - Tickets'
        }
      },
      {
        path: 'teams',
        name: 'TeamsTab',
        component: ProfileTabTeams,
        meta: {
          title: 'Profile - Teams'
        }
      },
      {
        path: 'challenges',
        name: 'ChallengesTab',
        component: ProfileTabChallenges,
        meta: {
          title: 'Profile - Challenges'
        }
      },
      {
        path: 'badges',
        name: 'BadgesTab',
        component: ProfileTabBadges,
        meta: {
          title: 'Profile - Badges'
        }
      }
    ]
  }
];
